export function escapeCharactersToHTMLTag(stringVal) {
  let resultString = stringVal;
  if (resultString && resultString.includes('\\n')) {
    resultString = resultString.replace(/\\n/g, '<br/>');
  }
  return resultString;
}
